module.exports = __webpack_public_path__ + "static/media/openIdFlow.d437645b.png";